import { gql } from "@apollo/client";
import { ContactPersonFields } from "../fragments/contactPersonFields";

/**
 * Contact assignments of a node, inherited ones included by default
 * (filter.includeInherited). `inheritedFrom` is null for a direct assignment;
 * for an inherited one it names the ancestor the assignment sits on —
 * `pathNodes` is selected so the contact tab can navigate the tree there.
 * A person assigned both directly and on an ancestor appears once, as direct.
 * Sorting is limited to `name` by the backend.
 */
export const InstalledBaseNodeContactPersonList = gql`
    query InstalledBaseNodeContactPersonList($nodeId: ID!, $filter: ContactPersonAssignmentListFilter, $search: SearchInput, $pagination: Pagination) {
        installedBaseNode(id: $nodeId) {
            id
            contactPersonList(filter: $filter, search: $search) {
                total
                assignments(pagination: $pagination, sort: {name: asc}) {
                    id
                    inheritedFrom {
                        id
                        title
                        pathNodes {
                            id
                        }
                    }
                    contactPerson {
                        ...ContactPersonFields
                    }
                }
            }
        }
    }
    ${ContactPersonFields}
`;
